import { Clickable, Col, Icon, Input, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin: 10px 0 0;
  max-width: 1000px;
`;

const Tag = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  background-color: ${theme.SECONDARY};
  margin: 0 5px 5px 0;
  border-radius: 5px;
`;

const Tags = ({ handleChange, definedTags }) => {
  const [value, setValue] = useState(''),
    [isFocused, setIsFocused] = useState(''),
    [tags, setTags] = useState([]);

  useEffect(() => {
    if (!definedTags) return;

    setTags(definedTags);
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  useEffect(() => {
    handleChange(tags);
  }, [tags]);

  function handleFocus() {
    setIsFocused(!isFocused);
  }

  function handleKeyDown(e) {
    if (e.keyCode !== 13 || !isFocused) return;

    addtag();
  }

  function addtag() {
    setTags([...tags, value]);
    setValue('');
  }

  function removeTag(tag) {
    const filtered = tags.filter((x) => x !== tag);

    setTags(filtered);
  }

  return (
    <Col marg="0 0 20px">
      <Input
        admin
        placeholder="Tags"
        onChange={({ target }) => setValue(target.value)}
        value={value}
        onFocus={handleFocus}
        onBlur={handleFocus}
      />

      <TagsWrapper>
        {tags.map((tag, i) => (
          <Tag key={i}>
            <Text col="#fff">{tag}</Text>

            <Clickable onClick={() => removeTag(tag)}>
              <Icon type="close" dimensions="15" marg="0 0 0 10px" />
            </Clickable>
          </Tag>
        ))}
      </TagsWrapper>
    </Col>
  );
};

export default Tags;
